import { gql } from 'graphql-request';

const Contact = gql`
  fragment Contact on ContactBlock {
    form {
      id
      formFields {
        label
        name: cleanName
      }
    }
    captchaKey
    title
    image {
      ... on ImageObjectType {
        sm: rendition(fill: "500x200-c100") {
          url
        }
        xl: rendition(fill: "960x500-c100") {
          url
        }
      }
    }
  }
`;

export default Contact;
